import { environment } from "src/environments/environment";

export function getFormioEnvironment() {
    return environment;
}